import React from 'react';
import { graphql, Link } from 'gatsby';
import Container from '../components/layout/container';
import GraphQLErrorList from '../components/graphql-error-list';
import SEO from '../components/layout/seo';
import ContentSections from '../components/pagebuilder/content-sections';
import { cn } from '../lib/helpers';
import { grid } from '../components/pagebuilder/section-grid/grid.module.css';
import ItemCell from '../components/itemCell';
import Section from '../components/sections/section';
import SectionTitle from '../components/reusecore/SectionTitle';
import Heading from '../components/reusecore/Heading';
import BlockContent from '../components/block-content';
import { Breadcrumbs } from '@material-ui/core';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getGatsbyImageData } from 'gatsby-source-sanity';
import clientConfig from '../../client-config';
import { Col, Row } from '../components/reusecore/Layout';
import SidebarProduct from '../components/layout/sidebarProduct';
import SectionHero from '../components/pagebuilder/section-hero';
import Navigation from '../components/sections/cycle/Navigation';
import { sortByItemType } from '../utils/tools';

export const query = graphql`
  query ManufacturerTemplateQuery($id: String!) {
    page: sanityManufacturer(id: { eq: $id }) {
      ...Manufacturer
    }
    items: allSanityItem(filter: { manufacturer: { id: { eq: $id } } }) {
      nodes {
        ...Item
      }
    }
    allItems: allSanityItem(filter: { slug: { current: { ne: null } } }) {
      nodes {
        ...Item
      }
    }
    manufacturers: allSanityManufacturer(
      filter: { slug: { current: { ne: null } } }
      sort: { fields: _updatedAt, order: DESC }
    ) {
      nodes {
        ...Manufacturer
      }
    }
    itemTypes: allSanityItemType(
      filter: { slug: { current: { ne: null } } }
      sort: { fields: _updatedAt, order: DESC }
    ) {
      nodes {
        ...ItemType
      }
    }
  }
`;

const ManufacturerTemplate = (props) => {
  const {
    data: { page, items, allItems, manufacturers, itemTypes },
    errors,
  } = props;

  const { name, seo, seoImage, _rawBody, logo, hero, smallHero } = page;
  const seoDescription = seo?.meta_description;
  const pageTitle = name || 'Untitled';
  const seoTitle = seo?.seo_title;
  const gatsbyImageData = getGatsbyImageData(logo, { layout: 'constrained', maxWidth: 675 }, clientConfig.sanity);

  const sortedItemTypes = sortByItemType(itemTypes);

  return (
    <>
      <Navigation />
      <SectionHero smallHero={smallHero} hero={hero} />
      {errors && <SEO title="GraphQL Error" />}
      {page && (
        <SEO
          title={pageTitle}
          seoImage={seoImage?.asset?.img?.src}
          seoTitle={seoTitle}
          description={seoDescription}
          keywords={page.seoKeywords}
          path={props.location.pathname}
        />
      )}

      {errors && (
        <Container>
          <GraphQLErrorList errors={errors} />
        </Container>
      )}
      <Section>
        <Container>
          <SectionTitle UniWidth="65%">
            <Heading as="h2">{name}</Heading>
            <div style={{ margin: '0 auto', maxHeight: '250px', maxWidth: '250px' }}>
              {logo && <GatsbyImage image={gatsbyImageData} alt={logo.alt} />}
            </div>
            {_rawBody && <BlockContent blocks={_rawBody} />}
          </SectionTitle>
          <div style={{ margin: '0 auto 2rem' }}>
            <div style={{ margin: '2rem auto' }}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link to="/shop">Shop</Link>
                <Link to={`/${items.nodes[0].itemType.slug.current}`}>{items.nodes[0].itemType.title}</Link>
                <span>{name}</span>
              </Breadcrumbs>
            </div>
          </div>
          <Row reverseMobile>
            <Col xs={12} lg={3}>
              <SidebarProduct itemTypes={sortedItemTypes} manufacturers={manufacturers} items={allItems} />
            </Col>
            <Col xs={12} lg={9}>
              <Row>
                <Col className="xs-12">
                  <ol className={cn(grid, 'four_columns')}>
                    {items?.nodes?.map((item) => (
                      <li key={item.id}>
                        <ItemCell noMargin item={item} />
                      </li>
                    ))}
                  </ol>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        {page && page.content && <ContentSections content={page.content} />}
      </Section>
    </>
  );
};

export default ManufacturerTemplate;
